import { DashboardSettings } from "@Utilities/dashboard"
import { useRouter } from "vue-router"

export default function useDashboard() {
    const router = useRouter()
    const { dimension, attribute, type } = router.currentRoute.value.params
    const { sort } = router.currentRoute.value.query

    // pull dimension attribute settings from dashboard settings
    let settings = DashboardSettings.find( (obj) => obj.dimension === dimension )
    settings = settings?.permutation.find( (obj) => obj.name === attribute )

    if ( !sort )
        settings =settings?.attributes.find( (obj) => obj.name === type )?.settings

    if ( sort )
        settings = settings?.attributes.find( (obj) => obj.name === "sort" && obj.type.name === type )?.type.settings

    return { // you can define multiple properties that can be use in dashboards
        settings
    }
}
